import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { SelfOrderInvoiceStatusTypesEnum, ShippingStatusType, SalesSubChannelTypesEnum } from '@shared/constants';

@Pipe({
  name: 'invoiceProcessStatus',
})
export class InvoiceProcessStatusPipe implements PipeTransform {

  private shippingStatus (value: ShippingStatusType): string {
    switch (value) {
      case ShippingStatusType.open:
        return 'invoice_shopping_status_open';
      case ShippingStatusType.readyForShipping:
        return 'invoice_shopping_status_ready_for_shipping';
      case ShippingStatusType.fulfilled:
        return 'invoice_shopping_status_fulfilled';
      default:
        return value;
    }
  }

  private selfOrderStatus(value: SelfOrderInvoiceStatusTypesEnum): string {
    switch (value) {
      case SelfOrderInvoiceStatusTypesEnum.OPEN:
        return 'self-order.order.preparation-status.open';
      case SelfOrderInvoiceStatusTypesEnum.IN_PREPARATION:
        return 'self-order.order.preparation-status.preparation';
      case SelfOrderInvoiceStatusTypesEnum.READY:
        return 'self-order.order.preparation-status.ready';
      default:
        return value;
    }
  }

  private processStatusMatrix: Partial<Record<SalesSubChannelTypesEnum, Function>> = {
    [SalesSubChannelTypesEnum.WEBSHOP]: this.shippingStatus,
    [SalesSubChannelTypesEnum.SELFORDER]: this.selfOrderStatus,
  }

  transform(value: string, subChannel: SalesSubChannelTypesEnum = SalesSubChannelTypesEnum.WEBSHOP): string {
    return this.processStatusMatrix[subChannel](value);
  }
}
@NgModule({
  declarations: [InvoiceProcessStatusPipe],
  exports: [InvoiceProcessStatusPipe],
})
export class InvoiceProcessStatusPipeModule {}
